import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'
import { useCallback, useEffect, useState } from 'react'

import {
  calcSortParamsSection,
  resolveSortOrder
} from '@aytm/app/stats/page/question-views/info-view/lib/report-params'
import { calcTableProps } from '@aytm/app/stats/page/question-views/info-view/lib/table-utils'

import { calcSortOrder } from '@aytm/app/stats/page/question-views/oe/lib/table-utils'

import { getModelValue } from '@aytm/app/stats/lib/stat-page'

// components
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

import { default as TableContainer } from '@aytm/app/stats/components/data-views/table/components/Table'

const Table = ({ id, link, block, format, answer, params, isSurveyGuest, isReportXpert, onParamsChange }) => {
  const [sortOrder, setSortOrder] = useState(() => resolveSortOrder(params?.s))

  // the report is what remembers the order, so one arriving from outside - a saved report opening,
  // a reset - replaces what is on screen
  useEffect(() => setSortOrder(resolveSortOrder(params?.s)), [params?.s])

  const onSort = useCallback(
    (colIndex, dir, cols) => {
      const order = calcSortOrder(cols, colIndex, dir)
      if (!order) return

      setSortOrder(order)
      onParamsChange?.(calcSortParamsSection(order))
    },
    [onParamsChange]
  )

  // read per render, so a change to the report's setting reaches the figures on the next draw
  const percentDecimals = getModelValue('percentDecimals')

  const tableProps = calcTableProps({ block, format, answer, sortOrder, onSort, percentDecimals })

  return (
    <BlockWrapper {...{ id, link, isSurveyGuest, isReportXpert }}>
      <TableContainer cols={tableProps.cols} rows={tableProps.rows} onSort={tableProps.onSort} />
    </BlockWrapper>
  )
}

Table.displayName = 'Table'

Table.propTypes = {
  id: PropTypes.string,
  link: PropTypes.string,
  block: PropTypes.object,
  format: PropTypes.object,
  answer: answerPropType,
  params: PropTypes.object,
  isReportXpert: PropTypes.bool,
  isSurveyGuest: PropTypes.bool,
  onParamsChange: PropTypes.func
}

export default Table
